import { UIText1, UIText2 } from '@cian/ui-kit';

interface IDescriptionRowProps {
  label: string;
  text: string;
  action?(): void;
}

export const DescriptionRow = ({ label, text, action }: IDescriptionRowProps) => {
  return (
    <div>
      {label && <UIText1>{label}</UIText1>}
      <span>
        <UIText2 whiteSpace="pre-line">{text}</UIText2>
        {action && (
          <UIText2 color="text-main-default" onClick={action}>
            Развернуть
          </UIText2>
        )}
      </span>
    </div>
  );
};
